#import "../fragments/groupFragment.graphql"

mutation updateTeamAttributes($groupId: ID!, $attributes: [AttributesInput]) {
  group: updateGroupAttributes(groupId: $groupId, attributes: $attributes) {
    ...GroupFragment
  }
}
